import React, {useState} from "react";
import { Modal, ModalHeader, ModalContent, ModalClose } from "bcms-react";
import { SVGAsset } from "res";

import "./styles.css";
import"./mobile.css";

const CustomModalContext = React.createContext(null);

/**
 * @function FullPageModal
 * @description Main modal component for full page modals, wraps all full page modal content.
 * @param {STRING} headerText - sets the header text for the modal.
 * @param {STRING} className - Allows us to set a unique className for the modal.
 * @param {STRING} id   - Sets the id of the modal (this modal has to be set in the index.jsx file of the components folder inside of CustomModal).
 * @returns {React.Component}
 * @example
 * function TestFullPageModal(props) {
 *  return (
 *    <FullPageModal id="TestFullPageModal headerText="Test Header" className="test-full-page-modal">
 *      <FullPageModalContent>
 *        <p>Hello World</p>
 *      </FullPageModalContent>
 *   </FullPageModal>
 *   );
 * }
 */
export default function FullPageModal(props) {
  const [ titleState, setTitleState ] = useState(props.headerText ?? "[Modal Header");
  const className = props.className ?? "";
  const id = props.id ?? "";

  return(
    <CustomModalContext.Provider value={{ titleState, setTitleState }}>
      <Modal className={ `full-page-modal ${ className }` }>
        <ModalHeader className="flex-container flex-horizontal align-center">
          <div className="flex-width">
            <h2 className="modal-header">{ titleState }</h2>
          </div>
          <ModalClose id={ id } className="set-width clickable">
            <SVGAsset id="CloseX" />
          </ModalClose>
        </ModalHeader>
        { props.children }
      </Modal>
    </CustomModalContext.Provider>
  );
}

export const useCustomModal = () => React.useContext(CustomModalContext);

/**
 * @function FullPageModalContent
 * @description The modal content component for a FullPageModal.
 * @returns {React.Component}
 * @example
 * <FullPageModalContent>
 *  <p>Hello world</p>
 * </FullPageModalContent>
 */
export function FullPageModalContent(props) {
  return(
    <ModalContent>
      { props.children}
    </ModalContent>
  );
}